import { createI18n } from 'vue-i18n'
import messages from '@intlify/unplugin-vue-i18n/messages'

const i18n = createI18n({
  legacy: false,
  locale: 'de',
  messages: messages
})

export const { t } = i18n.global
export default i18n
